import { RootState } from "@/app/stores";

export const selectWhitelistedPhones = (state: RootState) => state.phoneWhitelist.whitelistedPhones;
export const selectWhitelistedPhonesLoading = (state: RootState) => state.phoneWhitelist.isWhitelistedPhonesLoading;
export const selectWhitelistedPhonesFirstLoad = (state: RootState) => state.phoneWhitelist.isWhitelistedPhonesFirstLoad;
export const selectWhitelistedPhonesError = (state: RootState) => state.phoneWhitelist.whitelistedPhonesError;
export const selectBulkImportResult = (state: RootState) => state.phoneWhitelist.bulkImportResult;

